import "./ArtistModal.scss";

import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { api } from "../../../utils/api";

export default function SendGigInviteModal({ show, handleClose, artist }) {
  const [jobPostingId, setJobPostingId] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    setError(null);
    setSuccess(false);
    setSending(true);
    try {
      await api.post(`/users/${artist.user_id}/gig_invites`, {
        job_posting_id: Number(jobPostingId),
      });
      setSuccess(true);
      setJobPostingId("");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to send invite. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleExited = () => {
    setJobPostingId("");
    setError(null);
    setSuccess(false);
  };

  return (
    <Modal className="__artist-modal" show={ show } onHide={ handleClose } onExited={ handleExited } centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Gig Invite</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          Send { artist.name ? artist.name : artist.display_name } an email inviting them to a job posting
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Job Posting ID</Form.Label>
            <Form.Control
              type="number"
              value={ jobPostingId }
              onChange={ (e) => setJobPostingId(e.target.value) }
            />
          </Form.Group>
        </Form>
        { error && (
          <div className="text-danger mt-2">{ error }</div>
        ) }
        { success && (
          <div className="text-success mt-2">Invite sent.</div>
        ) }
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-tertiary" onClick={ handleClose } disabled={ sending }>Cancel</Button>
        <Button
          className={ `ppy-btn ppy-btn-primary${ sending || !jobPostingId ? " disabled" : "" }` }
          onClick={ handleSend }
          disabled={ sending || !jobPostingId }
        >
          Send Invite
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
